import { Link } from 'react-router-dom';

export const HamptonNews = () => {
    return (
        <div className="container py-4">
            <h2>Hampton Beach Regatta</h2>
            <h3>In The News</h3>

            <Link className='btn btn-outline-primary' to="/hampton">Back to Notice</Link>
            <article>
                <h3>Hampton Union</h3>
                <p>
                    By Skyler Frink <br /> hamptonunion@seacoastonline.com<br />June 21, 2011 2:00 AM
                </p>
                <p>HAMPTON</p>
                <p>Beachgoers watched over the weekend as dozens of boats zipped by during the Hampton Beach Catamaran Regatta, which attracted racers from Canada, Rhode Island and Massachusetts.</p>
                <p>A Canadian team beat out eight other Formula 18-class boats, while a team from Scarborough, Maine, won the Hobie 16-class race. The winning F18 team, which consisted of Maxime Loiselle from Quebec City and Chris Brentice from Halifax, travels around the coast looking for races to participate in.</p>
                <p>"We're always looking for races," said Loiselle.</p>
                <p>Loiselle said he hopes to see more people get involved in catamaran races.</p>
                <p>"The main thing I love about catamarans is that you have to be in shape to race," he said.</p>
                <p>The F18 race was very close, with Loiselle's team winning by one point. Points are determined by placement in each round: one point is awarded for coming in first, two points for placing second, etc. The team with the fewest points by the end of the races wins.</p>
                <p>The H16 race was won by Doug Baker and Kristin Richard of Scarborough. Baker has been racing catamarans for more than 32 years.</p>
                <p>While the Hobie competition featured only four boats, it did not lack intensity.</p>
                <p>"Several of the races were almost a photo finish," he said. Baker cited strategy and a little bit of luck as to how his team won.</p>
                <p>Baker also said he hopes to see more people joining the sport in the future.</p>
                <p>"It isn't just for the rich," he said. "You can pick a Hobie up for $500 or $1,000."</p>
                <p>Baker's favorite part about catamaran racing, and the H16 races in particular, is that technology does not matter. As a testament to that fact, he said, he won in a 13-year-old boat.</p>
                <p>There were no accidents during the races, said Rick Bliss, who has worked for the regatta for more than 25 years.</p>
                <p>"It was a perfect weekend; we couldn't have asked for better weather. "There were five rounds for both races throughout the weekend, with five occurring each day."</p>
            </article>
        </div>
    );
};

export default HamptonNews;
